import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { AccountReportPermissionStateClass } from "./interfaces/AccountReportPermissionStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";


const initialState: AccountReportPermissionStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    accountReportPermissionList: [
        {
            Role: "",
            AccountObjectPermissionId: "",
            ShowReport: false,
            AllowCustomization: false,
            AllowAllUser: false,
            AllowOwnReport: false,
            AllowOwnTeam: false,
            AllowOwnProject: false,
            AllowOwnSubOrdinates: false,
            AccountReportCategoryId: "",
            ReportName: "",
            ReportDescription: "",
            ReportIconPath: "",
            SystemReportTypeId: "",
            SystemReportId: "",
            IsConsolidated: false,
            AccountId: 0,
            AccountRoleId: 0,
            AccountReportId: "",
            AllowOwnApproval: false,
        },
    ],
    nAccountReportId: "",
    nReportName: ""
}

interface IThunkApi {
    state: {
        accountReportPermission: AccountReportPermissionStateClass
    }
}

export const getvueAccountObjectPermissionsByAccountIdAndAccountReportIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/getvueAccountObjectPermissionsByAccountIdAndAccountReportId",
        async (arg, thunkApi) => {
            const response = await fetchAPI("api/v2/Reports/ObjectPermissions/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )
export const UpdatePermissionsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/UpdatePermissions",
        async (arg, thunkApi) => {
            const { AccountReportId, accountReportPermissionList } = arg;
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Reports/UpdatePermissions/" + AccountReportId, "POST", accountReportPermissionList, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )
export const deleteAccountReportAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Reports/v2/deleteAccountReport",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/EmployeeTypes/" + arg,"Delete","",true,"0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/Reports/" + arg, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

const accountReportPermissionSlice = createSlice({
    name: "accountReportPermission",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const { index, FieldName } = action.payload;

            const currentindex = index //state.accountReportPermissionList.findIndex((item : any) => item.AccountObjectPermissionId == AccountObjectPermissionId);
            const newArray = [...state.accountReportPermissionList];
            newArray[currentindex] = { ...newArray[currentindex], [FieldName]: true };
            state.accountReportPermissionList = newArray;


        },
        unCheckedState: (state, action) => {
            const { index, FieldName } = action.payload;
            const currentindex = index //state.accountReportPermissionList.findIndex((item) => item.AccountObjectPermissionId == AccountObjectPermissionId);
            const newArray = [...state.accountReportPermissionList];
            newArray[currentindex] = { ...newArray[currentindex], [FieldName]: false };
            state.accountReportPermissionList = newArray;

        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getvueAccountObjectPermissionsByAccountIdAndAccountReportIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getvueAccountObjectPermissionsByAccountIdAndAccountReportIdAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";

                if (JSON.parse(payload.Data.data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.accountReportPermissionList = [];
                } else {
                    state.accountReportPermissionList = JSON.parse(payload.Data.data);
                    state.accountReportPermissionList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.nAccountReportId = payload.Data.nAccountReportId;
                state.nReportName = payload.Data.nReportName;
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};

            })
            .addCase(getvueAccountObjectPermissionsByAccountIdAndAccountReportIdAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(UpdatePermissionsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(UpdatePermissionsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';

                state.accountReportPermissionList = [];
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(UpdatePermissionsAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(deleteAccountReportAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountReportAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountReportAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }
})

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState } = accountReportPermissionSlice.actions
export const AccountReportPermissionState = (state: RootState) => state.accountReportPermission
export default accountReportPermissionSlice.reducer


